import React, { forwardRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box } from '@mui/material';
import EmptyChart from './EmptyChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const M3PerKmPerHourChart = ({ monthly = [] }, ref) => {
  const months = monthly.map((m) => m.month);
  const m3PerKmHour = monthly.map((m) => m.m3PerKmPerHour);

  const data = {
    labels: months,
    datasets: [
      {
        label: 'm³ / km / sat',
        data: m3PerKmHour,
        borderColor: '#16a34a',
        backgroundColor: 'rgba(22, 163, 74, 0.15)',
        tension: 0.35,
        pointRadius: 3,
        pointHoverRadius: 5,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.raw} m³/km/sat`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        grid: {
          color: '#e5e7eb',
        },
        ticks: {
          callback: (value) => value.toFixed(3),
        },
      },
    },
  };

  if (!monthly.length) return <EmptyChart />;

  return (
    <Box sx={{ height: { xs: 200, md: 220 } }}>
      <Line ref={ref} data={data} options={options} />
    </Box>
  );
};

export default forwardRef(M3PerKmPerHourChart);
